import React from 'react';

export const AssistantTyping = ({ isLoading }: { isLoading: boolean }) => {
  if (!isLoading) return null;
  return (
    <div className="flex flex-col assistant-message">
      <div className="flex items-start opacity-70">
        <div className="text-text rounded-xl p-3 first-message bg-[#f4f4f4]">
          <div className="flex items-center space-x-1">
            <span className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:0s]" />
            <span className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:0.2s]" />
            <span className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:0.4s]" />
          </div>
        </div>
      </div>
    </div>
  );
};
